import * as Yup from "yup";
import { EMAIL_REGEX, nameRegex, phoneRegex } from "../../../../helpers";

export const validationSchema = Yup.object({
  name: Yup.string()
    .matches(
      nameRegex,
      "Branch name must contain only letters and be at least 2 characters."
    )
    .required("Name of branch is required."),
  address: Yup.string().required("Address is required."),
  latitude: Yup.number()
    .typeError("Latitude must be a valid number.")
    .required("Latitude is required."),
  longitude: Yup.number()
    .typeError("Longitude must be a valid number.")
    .required("Longitude is required."),
  countryId: Yup.string().required("Country is required."),
  stateId: Yup.string().required("State is required."),
  cityId: Yup.string().required("City is required."),
});

export const editAgentValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(
      nameRegex,
      "Name must contain only letters and be at least 2 characters."
    )
    .required("Full name is required."),
  email: Yup.string()
    .required("Email is required")
    .matches(
      EMAIL_REGEX,
      "Enter a valid email (e.g., user@example.com). Must not contain spaces, must include '@', and a valid domain."
    ),
  phoneNumber: Yup.string()
    .matches(phoneRegex, "Enter a valid phone number.")
    .required("Phone number is required."),
  roles: Yup.string().notRequired(),
  address: Yup.string().notRequired(),
});
